/* eslint-disable react/prop-types */
import React from 'react';
import { Typography } from 'antd';
import Table from 'components/Table';
import { CloseCircleOutlined } from '@ant-design/icons';

const { Title } = Typography;

const TablaGastos = ({
  gastos,
  columnsGasto,
  rowSelectionGasto,
  handleOnRowClickGasto,
  onClickExpandGasto,
  onClickAdd,
  hasAllViewPermission,
  permission,
  handleOnCancelGasto,
}) => (
  <>
    <Title level={4}>
      Gastos
    </Title>
    <Table
      cols={columnsGasto}
      data={gastos}
      rowSelection={rowSelectionGasto}
      handleOnRowClick={handleOnRowClickGasto}
      controls={{
        onClickEdit: onClickExpandGasto,
        onClickAdd,
      }}
      customActions={[
        {
          text: 'Cancelar',
          icon: <CloseCircleOutlined className="danger" />,
          onClick: handleOnCancelGasto,
        },
      ]}
      allowSearch={false}
      rowKey="id"
      hasAllViewPermission={hasAllViewPermission}
      permission={permission}
    />
  </>
);

export default TablaGastos;
